module.exports = __webpack_public_path__ + "assets/img/1861.ebb02982.svg";